<template>
  <div class="toast_comm" ref="toastComm">
    <p class="desc_toast" v-html="toastMsg"></p>
  </div>
</template>

<script>
export default {
  name: 'ToastPopup',
  props:{
    toastMsg: String,
  },
  data() {
    return {
      timeoutID0: null,
      timeoutID1: null,
      timeoutID2: null,
    }
  },
  mounted() {
    this.toastMotion();
  },
  beforeUnmount() {
    if (this.timeoutID0) clearTimeout(this.timeoutID0);
    if (this.timeoutID1) clearTimeout(this.timeoutID1);
    if (this.timeoutID2) clearTimeout(this.timeoutID2);
  },
  methods:{
    toastMotion(){
      const _this = this;

      this.timeoutID0 = setTimeout(function(){
        _this.$refs.toastComm.classList.add('active');
        this.timeoutID0 = null;
      }, 100);
      
      this.timeoutID1 = setTimeout(function(){
        _this.$refs.toastComm.classList.remove('active');
        this.timeoutID1 = null;
      }, 2100);
      
      this.timeoutID2 = setTimeout(function(){
        _this.$emit("onComplete");
        this.timeoutID2 = null;
      }, 2500);
    },
  }
}
</script>
<style lang="scss" scoped>
.toast_comm{position:fixed;top:0;left:20px;right:20px;z-index:9999;transition:.2s;text-align:center;opacity:0;}
.toast_comm .desc_toast{display:inline-block;max-width:100%;font-weight:700;font-size:14px;line-height:24px;color:#fff;letter-spacing:-.05em;padding:14px 30px;border-radius:$CONTENT_RADIUS;background-color:rgba(0,0,0,.7);text-align:center;vertical-align:top;word-break:break-word;white-space:initial}
.toast_comm.active{top:70px;opacity:1}
</style>